import { useEffect, useState } from "react"
import { getStateInfo } from "../../../../../helper/stateTranslate"
import logger from "../../../../../utils/logger"
import { dateFormat } from "../../../../../helper/dataFormat"

export const AccountSubscription = ({ memberData, stateModel }) => {

  const [translationStatus, setTranslationStatus] = useState(null)

  useEffect(() => {

    if (memberData.state) {

      const getState = getStateInfo(stateModel, memberData.state)
      logger.info('status translationStatus: ', getState)

      setTranslationStatus(getState)
    }

  }, [memberData])





  return (
    <div className="mp-user-dto ">

      <h4 className="mp-header-nav-title">Suscripciones</h4>

      <article className="mp-code-status">


        <div className="mp-user-status-title">
          <p className="status-title">Estado</p>
          <span className={`span-status span-${memberData?.state.toLowerCase()}`} >
            {translationStatus?.stateString}
          </span>
        </div>

        <div className="mp-member-code">

          <div className="id-card-icon">
            <span className="material-symbols-outlined notranslate mI-Id mI-color" aria-hidden="true" role="none">id_card</span>
          </div>

          <div className="mp-titles">
            <p className="member-title">Codigo de Membresia</p>
            <p className="code-number">{memberData?.cardcode}</p>
          </div>


        </div>


      </article>


      {memberData?.enrollments?.length > 0 && (
        <div className="mp-dates-container">
          <p className="mp-header-nav-subtitle">Historial de Suscripciones</p>

          <div className="mp-dates">
            <p className="mp-start-date">Fecha de Inicio</p>
            <p className="mp-expiration-date">Fecha de Expiracion</p>

          </div>

          <hr className="hr-dto-date" />
          {memberData.enrollments.filter(e => e.typeId == 1).map((enrollment, index) => {
            if (!enrollment) return null;

            return (


              <div key={index} className="mp-dates-1">
                <span className="mp-start-number">
                  {enrollment.approvedDate
                    ? dateFormat(enrollment.approvedDate)
                    : ""}
                </span>

                <span className="mp-expiration-number">
                  {enrollment.expirationDate
                    ? dateFormat(enrollment.expirationDate)
                    : ""}
                </span>
              </div>

            );
          })}
        </div>
      )}


    </div>
  )
}
